<template>
    <div class="flex flex-column">
        <label v-if="showLabel" :for="treeLabel" class="mb-2" :class="{ 'font-bold': bold }">{{ treeLabel }}:</label>
        <TreeSelect
            :class="{ 'p-invalid': props.errorMessage }"
            v-model="selectedTreeValue"
            :options="props.optionsTree"
            selectionMode="single"
            :placeholder="placeholderLabel(treeLabel)"
            scrollHeight="200px"
            @change="updateSelectedValue"
            :disabled="props.disabled"
        />
        <small class="p-invalid" v-if="props.errorMessage"> {{ props.errorMessage }}</small>
    </div>
</template>

<script setup>
import { ref, onMounted, computed, defineProps, defineEmits, watch } from 'vue';
import { placeholderLabel } from '../../utilities/index.js';
const emit = defineEmits(['update:modelValue']);
const props = defineProps({
    modelValue: {
        type: Number,
    },
    label: {
        type: String,
    },
    optionsTree: {
        type: Array,
    },
    errorMessage: {
        type: String,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    bold: {
        type: Boolean,
        default: false,
    },
    showLabel: {
        type: Boolean,
        default: true,
    },
});
const selectedTreeValue = ref(null);
const treeLabel = computed(() => {
    return props.label ?? null;
});

const treeModelValue = computed(() => {
    return props.modelValue;
});

watch(treeModelValue, () => {
    selectedTreeValue.value = { [treeModelValue.value]: true };
});

onMounted(() => {
    if (treeModelValue.value) {
        selectedTreeValue.value = { [treeModelValue.value]: true };
    }
});

const updateSelectedValue = () => {
    emit('update:modelValue', selectedTreeValue.value ? Number(Object.keys(selectedTreeValue.value)[0]) : null);
};
</script>
